// Copyright 2021 Linka Cloud  All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {Stack, SxProps, Typography, useTheme} from "@mui/material";
import React from "react";
import LinkaCloudIcon from "../icons/linka-cloud";

export interface HeaderProps {
  title: React.ReactNode;
  sx?: SxProps;
  disableLogo?: boolean;
}

export const Header = ({title, sx, disableLogo}: HeaderProps) => {
  const theme = useTheme();
  return (
    <>
      <Stack sx={{
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '&:first-letter': {
          textTransform: 'uppercase',
        },
        ...sx,
      }}>
        {!disableLogo && <LinkaCloudIcon sx={{width:48, height: 48, alignSelf: 'left'}}/>}
        <Typography variant="h4" sx={{textAlign: 'center'}}>{title}</Typography>
      </Stack>
    </>
  )
}
